import React from 'react';
import { Content } from 'antd/es/layout/layout';
import { Button } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';

import GeneralSettings from './GeneralSettings';
import { useContextSettings } from '../../../context/settings';

const Settings: React.FC = (): JSX.Element => {
  const { isDisabled, onSave, settingUpdate } = useContextSettings();

  return (
    <>
      <PageHeader
        title="Settings"
        extra={(
          <Button type="primary" disabled={isDisabled} onClick={onSave} loading={settingUpdate?.loading}>
            Save changes
          </Button>
        )}
      />
      <Content>
        <GeneralSettings />
      </Content>
    </>
  );
};

export default Settings;
